"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const root_navigation_1 = require("../navigation/root_navigation");
const types_1 = require("@voltmoney/types");
let panResponder;
class BottomSheet extends react_1.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
            animatedHeight: new react_native_1.Animated.Value(0),
            pan: new react_native_1.Animated.ValueXY(),
            calculatedHeight: 0,
            keyboardHeight: 0
        };
        if (!this.props.autoAdjustHeight) {
            this.createPanResponder(props);
        }
    }
    setModalVisible(visible) {
        var _a;
        const { closeFunction, height } = this.props;
        const { animatedHeight, pan, calculatedHeight, } = this.state;
        if (visible) {
            this.setState({ modalVisible: visible });
            react_native_1.Animated.timing(animatedHeight, {
                toValue: ((_a = this.props) === null || _a === void 0 ? void 0 : _a.autoAdjustHeight)
                    ? calculatedHeight
                    : height,
                duration: 300,
                useNativeDriver: false,
            }).start();
        }
        else {
            react_native_1.Animated.timing(animatedHeight, {
                toValue: 0,
                duration: 400,
                useNativeDriver: false,
            }).start(() => {
                pan.setValue({ x: 0, y: 0 });
                this.setState({
                    modalVisible: visible,
                    animatedHeight: new react_native_1.Animated.Value(0),
                });
                if (typeof closeFunction === 'function')
                    closeFunction();
            });
            (0, root_navigation_1.goBack)();
        }
    }
    createPanResponder(props, customHeight) {
        const { height } = props;
        const { pan } = this.state;
        panResponder = react_native_1.PanResponder.create({
            onStartShouldSetPanResponder: () => true,
            onPanResponderMove: (e, gestureState) => {
                if (gestureState.dy > 0) {
                    react_native_1.Animated.event([null, { dy: pan.y }], {
                        useNativeDriver: false,
                    })(e, gestureState);
                }
            },
            onPanResponderRelease: (e, gestureState) => {
                const gestureLimitArea = customHeight
                    ? customHeight
                    : height / 3;
                const gestureDistance = gestureState.dy;
                if (gestureDistance > gestureLimitArea) {
                    this.setModalVisible(false);
                }
                else {
                    react_native_1.Animated.spring(pan, {
                        toValue: { x: 0, y: 0 },
                        useNativeDriver: false,
                    }).start();
                }
            },
        });
    }
    componentDidMount() {
        if (!this.props.autoAdjustHeight)
            this.show();
        react_native_1.BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
        if (this.props.handleKeyboard) {
            this.showSubscription = react_native_1.Keyboard.addListener("keyboardDidShow", (e) => {
                console.log("Keyboard did show in iOS");
                this.setState({ keyboardHeight: e.endCoordinates.height });
            });
            this.hideSubscription = react_native_1.Keyboard.addListener("keyboardDidHide", () => {
                this.setState({ keyboardHeight: 0 });
            });
        }
    }
    componentWillUnmount() {
        clearTimeout(this.timer);
        react_native_1.BackHandler.removeEventListener('hardwareBackPress', this.handleBackButton);
        if (this.props.handleKeyboard) {
            this.showSubscription.remove();
            this.hideSubscription.remove();
        }
    }
    handleBackButton() {
        var _a;
        return (_a = this.props) === null || _a === void 0 ? void 0 : _a.isDismissible;
    }
    show() {
        this.setModalVisible(true);
    }
    close() {
        this.setModalVisible(false);
    }
    render() {
        const { children, hasDraggableIcon, sheetBackgroundColor, dragIconColor, dragIconStyle, draggable = true, radius = 4, } = this.props;
        const { animatedHeight, pan, modalVisible } = this.state;
        const panStyle = {
            transform: pan.getTranslateTransform(),
        };
        if (this.props.autoAdjustHeight &&
            this.state.calculatedHeight === 0) {
            return (react_1.default.createElement(react_native_1.View, { style: { opacity: 0 }, onLayout: (event) => {
                    clearTimeout(this.timer);
                    const { height } = event.nativeEvent.layout;
                    console.info(`**** calculated modal height for ${this.props.routeId} -> ', ${height}`);
                    this.createPanResponder(this.props, height);
                    this.timer = setTimeout(() => this.setState({
                        calculatedHeight: hasDraggableIcon
                            ? height + 80
                            : height,
                    }, () => {
                        this.show();
                    }), 100);
                } }, children));
        }
        const _renderDragIcon = (react_1.default.createElement(react_native_1.Animated.View, Object.assign({}, (draggable && panResponder.panHandlers), { style: styles.draggableContainer }),
            react_1.default.createElement(react_native_1.View, { style: [
                    styles.draggableIcon,
                    dragIconStyle,
                    {
                        backgroundColor: dragIconColor || '#A3A3A3',
                    },
                ] })));
        return (react_1.default.createElement(react_native_1.View, { style: [{
                    // flex: 1,
                    height: this.props.screenHeight,
                    width: this.props.screenWidth,
                    backgroundColor: '#25252599',
                },
                this.props.alignment === types_1.ModalAlignmentEnum.BOTTOM ? {
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                } : {}] },
            modalVisible && (react_1.default.createElement(react_native_1.Animated.View, { style: [
                    panStyle,
                    this.props.alignment === types_1.ModalAlignmentEnum.BOTTOM ? {
                        height: animatedHeight,
                        width: this.props.width ? this.props.width : '100%',
                        borderTopRightRadius: radius || 12,
                        borderTopLeftRadius: radius || 12,
                        backgroundColor: sheetBackgroundColor || '#F3F3F3',
                    } :
                        this.props.alignment === types_1.ModalAlignmentEnum.LEFT ? {
                            width: animatedHeight,
                            height: '100%',
                            position: 'absolute',
                            left: 0,
                            borderTopLeftRadius: radius || 12,
                            borderBottomLeftRadius: radius || 12,
                            backgroundColor: sheetBackgroundColor || '#F3F3F3',
                        } : this.props.alignment === types_1.ModalAlignmentEnum.RIGHT ? {
                            width: animatedHeight,
                            height: '100%',
                            position: 'absolute',
                            right: 0,
                            borderTopRightRadius: radius || 12,
                            borderBottomRightRadius: radius || 12,
                            backgroundColor: sheetBackgroundColor || '#F3F3F3',
                        } : {
                            height: animatedHeight,
                            width: '100%',
                            position: 'absolute',
                            top: 0,
                            borderBottomRightRadius: radius || 12,
                            borderBottomLeftRadius: radius || 12,
                            backgroundColor: sheetBackgroundColor || '#F3F3F3',
                        },
                ] },
                hasDraggableIcon && _renderDragIcon,
                children)),
            this.props.alignment === types_1.ModalAlignmentEnum.BOTTOM
                && this.state.keyboardHeight > 0 && (react_1.default.createElement(react_native_1.View, { style: { height: this.state.keyboardHeight } }))));
    }
}
exports.default = BottomSheet;
const styles = react_native_1.StyleSheet.create({
    wrapper: {
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    background: {
        flex: 1,
        backgroundColor: 'transparent',
    },
    container: {
        borderTopRightRadius: 10,
        borderTopLeftRadius: 10,
    },
    draggableContainer: {
        width: '100%',
        alignItems: 'center',
        backgroundColor: 'transparent',
        paddingBottom: 8,
    },
    draggableIcon: {
        width: 40,
        height: 6,
        borderRadius: 3,
        margin: 10,
        marginBottom: 0,
    },
});
//# sourceMappingURL=BottomSheet.js.map